var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBigCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.084 16.6666H17.4173C12.7923 16.6666 9.12565 20.375 9.12565 25L9.08398 75C9.08398 79.625 12.7923 83.3333 17.4173 83.3333H84.084C88.709 83.3333 92.4173 79.625 92.4173 75V25C92.4173 20.375 88.709 16.6666 84.084 16.6666ZM84.084 75H17.4173V50H84.084V75ZM84.084 33.3333H17.4173V25H84.084V33.3333Z",
    fill: "#0033AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBigCard);
export default __webpack_public_path__ + "static/media/ic_big_card.081c1f34df09dcc09313deca6d628e7e.svg";
export { ForwardRef as ReactComponent };